import { useQuery } from "react-query";

import MainCard from "components/layout/MainCard/MainCard";
import Button from "../../components/Buttons/Button/Button";
import LoadingWrapper from "../../components/Loading/LoadingWrapper";
import Sitemap from "../../routes/sitemap";
import useAPI from "../../hooks/useAPI";
import ProductItems from "../Catalogue/Products/ProductItems/ProductItems";
import StaticPage from "../../components/StaticPage/StaticPage";
import { useTranslation } from "react-i18next";
import scss from "./EmptyPage.module.scss";

const EmptyPage = ({ message, children, className, slug = null, setOpenDialog, translateKey, mobileHeader, stateIcon, actionLabel }) => {
    const { t } = useTranslation();
    const api = useAPI();

    // Load the products to promote
    const { data: products, isLoading } = useQuery(["EmptyPage.PromotedProducts"], () => api.list("/products/section/list/recommendation", { limit: 5, order_price: "desc" }));

    // Default message to show
    if (!message && !children) {
        message = "global-message-no_longer_available_page";
    }
    return (
        <MainCard className={className}>
            {mobileHeader}
            <div className={`${scss.container} ${stateIcon ? scss.withState : ""}`}>
                <section className={stateIcon ? scss.emptyState : undefined}>
                {stateIcon && <div className={scss.stateIcon}><img src={stateIcon} alt="" /></div>}
                {/* Just show the message */}
                {message && <h4 className={scss["heading"]}>{t(message)}</h4>}

                {/* Render the supplied children */}
                {!message && children}

                {/* Back to home button */}
                <Button className={stateIcon ? scss.continue : undefined} label={actionLabel ?? t("global-default-text-back_to_home")} to={Sitemap.home} onClick={() => setOpenDialog?.(false)} />
                </section>

                <StaticPage slug={slug ?? ""} />
                {/* Show the promoted products */}
                <h5 className={scss["sub-heading"]}>{t(`${translateKey}-text-promoted_products`)}:</h5>
                <LoadingWrapper isLoading={isLoading}>
                    <ProductItems products={products?.items} translateKey={translateKey} />
                </LoadingWrapper>
            </div>
        </MainCard>
    );
};

export default EmptyPage;
